import { useState, useEffect } from "react";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import Select from 'react-select';
import Network from "../../utils/Network";
import { Urls } from "../../utils/Constants";
import Loader from "../common/Loader";
import ConfirmAddBene from "../common/modal/confirmaddbene";
import ConfirmUpiAddBene from "../common/modal/confirmupiaddbene";
import ErrorSuccessModal from "../common/modal/errorsuccessmodal";
import ConfirmTransaction from "../common/modal/confirmtransaction";

export default function SecureMoneyTransfer() {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [mobile, setMobile] = useState("");
  const [showSenderDiv, setShowSenderDiv] = useState(0);
  const [orderId, setOrderId] = useState(0);
  const [senderName, setSenderName] = useState("");
  const [senderId, setSenderId] = useState("");
  const [otp, setOtp] = useState("");
  const [showSenderDetailDiv, setShowSenderDetailDiv] = useState(0);
  const [existingSenderName, setExistingSenderName] = useState("");
  const [existingSenderMob, setExistingSenderMob] = useState("");
  const [accountDetailBoxDiv, setAccountDetailBoxDiv] = useState(0);
  const [beneAccountNo, setBeneAccountNo] = useState("");
  const [beneSearchFlag, setBeneSearchFlag] = useState(0);
  const [beneList, setBeneList] = useState([]);
  const [showBeneListDiv, setShowBeneListDiv] = useState(0);
  const [showSearchAccountDiv, setShowSearchAccountDiv] = useState(0);
  const [showSenderSearchBoxDiv, setShowSenderSearchBoxDiv] = useState(1);
  const [accountNo, setAccountNo] = useState("");
  const [showAddBeneBoxDiv, setShowAddBeneBoxDiv] = useState(0);
  const [bankList, setBankList] = useState([]);
  // const selectedElement = useRef();
  const [selectedBankName, setSelectedBankName] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [accountNoAddBene, setAccountNoAddBene] = useState("");
  const [beneNameAddBene, setBeneNameAddBene] = useState("");
  const [upiIdSearch, setUpiIdSearch] = useState("");
  const [upiBeneList, setUpiBeneList] = useState([]);
  const [beneAddInsertedId, setBeneAddInsertedId] = useState(0);
  const [showAddBeneConfirmPopUp, setShowAddBeneConfirmPopUp] = useState(0);
  const [isBeneVerify, setIsBeneVerify] = useState(0);
  const [showUpiBeneListTable, setShowUpiBeneListTable] = useState(0);
  const [showAddUpiBeneForm, setShowAddUpiBeneForm] = useState(0);
  const [upiAddress, setUpiAddress] = useState("");
  const [mobileAddUpi, setMobileAddUpi] = useState("");
  const [upiAddInsertedId, setUpiAddInsertedId] = useState(0);
  const [showAddUpiConfirmPopUp, setShowAddUpiConfirmPopUp] = useState(0);
  const [beneNameAddUpi, setBeneNameAddUpi] = useState("");
  const [upiSearchFlag, setupiSearchFlag] = useState(0);
  const [inputAmount, setInputAmount] = useState("");
  const [confirmTransactionModal, setConfirmTransactionModal] = useState(0);
  const [transactionId, setTransactionId] = useState("");
  const [transactionPopServiceName, setTransactionPopServiceName] = useState("");
  const [transactionPopBankName, setTransactionPopBankName] = useState("");
  const [transactionPopTxnDate, setTransactionPopTxnDate] = useState("");
  const [transactionPopAmount, setTransactionPopAmount] = useState("");
  const [transactionPopMobile, setTransactionPopMobile] = useState("");
  const [transactionPopAccountNo, setTransactionPopAccountNo] = useState("");
  const [transactionPopCustomerName, setTransactionPopCustomerName] = useState("");
  const [transactionPopMethod, setTransactionPopMethod] = useState("");
  const [isErrorFlag, setIsErrorFlag] = useState(0);
  const [showErrorSuccessModal, setShowErrorSuccessModal] = useState(0);
  const [modalMsg, setModalMsg] = useState("");

  const openModal = (type) => {
    switch(type){
      case 'Error':
        setIsErrorFlag(1);
        setShowErrorSuccessModal(1);
      break;
      case 'Success':
        setIsErrorFlag(0);
        setShowErrorSuccessModal(1);
      break;
    }    
  };
  const closeModal = (type) => {
    if(type === 'Success' || type === 'Error'){
      setIsErrorFlag(0);
      setShowErrorSuccessModal(0);
    }
  };

  const openAddBeneConfirmModal = () => setShowAddBeneConfirmPopUp(1);
  const closeAddBeneConfirmModal = () => setShowAddBeneConfirmPopUp(0);
  const openUpiModal = () => setShowAddUpiConfirmPopUp(1);
  const closeUpiModal = () => setShowAddUpiConfirmPopUp(0);
  const openConfirmTransactionModal = () => setConfirmTransactionModal(1);
  const closeConfirmTransactionModal = () => setConfirmTransactionModal(0);

  const submitVerification = async (event) => {
    event.preventDefault();
    const newErrors = errorHandling('mobile');
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      verification();
    }
  }
  const showBeneList = () => {
    setMobile(beneAccountNo);
    setBeneSearchFlag(1);
  }
  useEffect(() => {
    console.log(beneSearchFlag);
    if(beneSearchFlag === 1){
      verification();
    }
  },[beneSearchFlag])

  const verification = async () => {
    let formData = new FormData();
    const localStorageDataStr = localStorage.getItem('token');
    const item = JSON.parse(localStorageDataStr);
    formData.append("api_token", item.token);
    formData.append("mobile", mobile.trim());
    try {
      setLoading(true); // Show loader
      const response = await Network.post(Urls.baseUrlPostLogin + '/verification', formData);
      if (response?.data?.status === 0) {
        setOrderId("");
        setSenderId(response.data.sender_id);
        setShowSenderDiv(0);
        setSenderName('');
        setOtp("");
        setShowSenderDetailDiv(1);
        setShowBeneListDiv(1);
        setShowSearchAccountDiv(1);
        setShowSenderSearchBoxDiv(0);
        setAccountDetailBoxDiv(0);
        setExistingSenderName(response.data.sender_name);
        setExistingSenderMob(response.data.sender_number);
        getBeneList(1);
      } else {
        setShowSenderDetailDiv(0);
        setOrderId(response.data.order_id);
        setShowSenderDiv(1);
        setShowBeneListDiv(0);
        setShowSearchAccountDiv(0);
        setShowSenderSearchBoxDiv(1);
      }
    } catch (err) {
      console.log('error', err);
      setModalMsg(err);
      openModal('Error');
    } finally {
        setLoading(false); // Hide loader
    }
  }
  const senderRegistration = async () => {
    const newErrors = errorHandling('senderRegistration');
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("mobile", mobile.trim());
      formData.append("name", senderName);
      formData.append("otp", otp.trim());
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/sender-registration', formData);
        if(response?.data?.status === 0){
            setOrderId(response.data.order_id);
            setShowSenderDiv(0);
            getBeneList(1);
            setShowBeneListDiv(1);
        }else{
            errorHandling('incorrectOtp');
        }
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      } finally {
        setLoading(false); // Hide loader
      }
    }
  }
  const searchByAccount = async() => {
    const newErrors = errorHandling('searchByAccount');
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("account_number", beneAccountNo.trim());
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/search-by-account', formData);
        setAccountDetailBoxDiv(1);
        if(response?.data?.bene_list?.length > 0){
            // setBeneList(result => [...result, ...response.data.bene_list]);
            setBeneList(response.data.bene_list);
        }
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      } finally {
        setLoading(false); // Hide loader
      }
    }
  }
  const getBeneList = async(type) => {
    if(type === 0){
      var newErrors = errorHandling('beneList');
    }else{
      var newErrors = errorHandling('mobile');
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("mobile", mobile.trim());
      if(type === 0){
        formData.append("account_number", accountNo.trim());
      }
      formData.append("type", type);
      try {
        const response = await Network.post(Urls.baseUrlPostLogin + '/beneficiary-list', formData);
        if(response?.data?.status === 0){
          setBeneList(response.data.bene_list);
        }else{
          setBeneList([]);
        }
        setShowAddBeneBoxDiv(0);
        setShowBeneListDiv(1);
        setShowUpiBeneListTable(0);
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      }
    }
  }
  const accountVerification = async() => {
    const newErrors = errorHandling('accountVerify');
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("mobile", mobile.trim());
      formData.append("account_number", accountNoAddBene.trim());
      formData.append("bank_name", selectedBankName);
      formData.append("ifsc_code", ifsc.trim());
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/account-verification', formData);
        if(response?.data?.status === 0){
          setBeneAddInsertedId(response.data.insert_id);
          openAddBeneConfirmModal();
        }else{
          setModalMsg(response.data.message);
          openModal('Error');
        }
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      } finally {
        setLoading(false); // Hide loader
      }
    }
  }
  const accountVerificationConfirm = async() => {
    const newErrors = errorHandling('accountVerify');
    setErrors(newErrors);
    console.log(beneAddInsertedId);
    if (Object.keys(newErrors).length === 0) {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("insert_id", beneAddInsertedId);
      formData.append("mpin", 1234);
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/account-verification-confirm', formData);
        if(response?.data?.status === 0){
          setBeneAddInsertedId(0);
          setIsBeneVerify(response.data.bene_veriry);
          setBeneNameAddBene(response.data.bene_name);
          closeAddBeneConfirmModal();
        }else{
          const apiErrors = {beneNameAddBene : response.data.message};
          setErrors(apiErrors);
        }
        closeModal();
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      } finally {
        setLoading(false); // Hide loader
      }
    }
  }
  const showAddBeneBox = () => {
    setShowBeneListDiv(0);
    setShowAddBeneBoxDiv(1);
    setIfsc("");
    getBankList();
  }
  const getBankList = async() => {
      try {
        const localStorageDataStr = localStorage.getItem('token');
        const item = JSON.parse(localStorageDataStr);
        const response = await Network.get(Urls.baseUrlPostLogin + '/bank-details?api_token='+item.token);
        if(response?.data?.status === 'success'){
            const bankOptions = response.data.bank_list.map(item => ({
                value: item.bank_id,
                label: item.bank_name
            }));
            setBankList(bankOptions);
        }
      } catch (err) {
        console.log('error', err);
      }
  }
  const getIfsc = async(option) => {
    // const selectedOption = selectedElement.current.options[selectedElement.current.selectedIndex];
    // const newErrors = errorHandling('getIfsc');
    // setErrors(newErrors);
    // if (Object.keys(newErrors).length === 0) {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      if(option.label !== undefined){
        formData.append("bank_name", option.label);
        setSelectedBankName(option.label);
      }else{
        formData.append("bank_name", selectedBankName);
      }
      try {        
        const response = await Network.post(Urls.baseUrlPostLogin + '/get-ifsc', formData);
        if(response?.data?.status === 0){
          setIfsc(response.data.ifsc);
        }
      } catch (err) {
        console.log('error', err);
      }
    // }
  }
  const addBeneficiary = async() => {
    const newErrors = errorHandling('addBeneficiary');
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("mobile", mobile.trim());
      formData.append("bene_name", beneNameAddBene);
      formData.append("account_number", accountNoAddBene.trim());
      formData.append("ifsc_code", ifsc.trim());
      formData.append("bank_name", selectedBankName);
      formData.append("bene_verify", isBeneVerify);
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/add-beneficiary', formData);
        if(response?.data?.status === 0){
          setSelectedBankName("");
          setBankList([]);
          setAccountNoAddBene("");
          setIfsc("");
          setBeneNameAddBene("");
          setShowAddBeneBoxDiv(0);
          setAccountNo(accountNoAddBene.trim());
          // getBeneList(0);
          setBeneSearchFlag(1);
        }else{
          setModalMsg(response.data.message);
          openModal('Error');
        }
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      } finally {
        setLoading(false); // Hide loader
      }
    }
  }
  const deleteBene = async(beneId) => {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("bene_id", beneId);
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/delete-beneficiary', formData);
        if(response?.data?.status === 0){
          getBeneList(1);
        }
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      } finally {
        setLoading(false); // Hide loader
      }
  }
  const getUpiList = async(type) => {
    var newErrors = {};
    if(type === 0){
    var newErrors = errorHandling('upiList');
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("mobile", mobile.trim());
      formData.append("type", type);
      if(type === 0){
      formData.append("upi_id", upiIdSearch);
      }
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/vpa/upi-list', formData);
        if(response?.data?.status === 0){
          setUpiBeneList(response.data.bene_list);
          setShowUpiBeneListTable(1);
          setShowAddUpiBeneForm(0);
        }else{
          const apiErrors = {upiIdSearch : response.data.message};
          setErrors(apiErrors);
          setUpiAddress(upiIdSearch);
          setUpiIdSearch("");
        }
        setShowBeneListDiv(0);
        setShowUpiBeneListTable(1);
      } catch (err) {
        console.log('error', err);
      } finally {
        setLoading(false); // Hide loader
      }
    }
  }
  const showAddUpiBeneBox = () => {
    setShowUpiBeneListTable(0);
    setShowAddUpiBeneForm(1);
  }
  const upiVerification = async() => {
    const newErrors = errorHandling('upiVerification');
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("mobile", mobileAddUpi.trim());
      formData.append("upi_address", upiAddress);
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/vpa/create/report', formData);
        if(response?.data?.status === 0){
          setUpiAddInsertedId(response.data.insert_id);
          openUpiModal();
        }
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      } finally {
        setLoading(false); // Hide loader
      }
    }
  }
  const upiVerificationConfirm = async() => {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("insert_id", upiAddInsertedId);
      formData.append("mpin", 1234);
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/vpa/confirm/verify', formData);
        if(response?.data?.upi_verify === 1){
          setBeneNameAddUpi(response.data.name);
          setUpiAddInsertedId(0);
        }else{
          const apiErrors = {upiAddress : response.data.message};
          setErrors(apiErrors);
        }
        closeUpiModal();
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      } finally {
        setLoading(false); // Hide loader
      }
  }
  const addUpiBeneficiary = async() => {
    const newErrors = errorHandling('addUpiBeneficiary');
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("sender_mobile", mobile.trim());
      formData.append("sender_id", senderId.trim());
      formData.append("upi_address", upiAddress);
      formData.append("bene_name", beneNameAddUpi);
      formData.append("bene_mobile", mobileAddUpi);
      formData.append("bene_verify", 1);
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/add/vpa/bene', formData);
        if(response?.data?.status === 'success'){
          setUpiAddress("");
          setBeneNameAddUpi("");
          setMobileAddUpi("");
          setUpiIdSearch(upiAddress);
          setShowAddUpiBeneForm(0);
          setupiSearchFlag(1);
        }else{
          const apiErrors = {upiAddress : response.data.message};
          setErrors(apiErrors);
        }
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      } finally {
        setLoading(false); // Hide loader
      }
    }
  }
  useEffect(() => {
    if(upiSearchFlag === 1){
      getUpiList(0);
    }
  },[upiSearchFlag])

  const deleteUpiBene = async(beneId) => {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("bene_id", beneId);
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/vpa/delete-bene', formData);
        if(response?.data?.status === 0){
          getUpiList(1);
        }
      } catch (err) {
        console.log('error', err);
      } finally {
        setLoading(false); // Hide loader
      }
  }
  const handleChange = (key, event) => {
    setInputAmount({
      ...inputAmount,
      [key] : event.target.value,
    });
  };
  const createTransaction = (key,item,channel) => {
    var errors = {};
    if(!inputAmount[key]){
      errors = {[key] : "Please provide amount"};
    }else if(inputAmount[key] < 4){
      errors = {[key] : "Please provide valid amount"};
    }
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      const params = {
        beneficiary_id: item.bene_id,
        amount: inputAmount[key],
        account_number: item.account_number,
        mobile: mobile.trim(),
        channel: channel,
        bene_name: item.bene_name,
        bank_name: item.bank_name,
        ifsc: item.ifsc
      }
      secureTransaction(params);
    }
  }
  const secureTransaction = async(params) => {   
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("beneficiary_id", params.beneficiary_id);
      formData.append("amount", params.amount);
      formData.append("account_number", params.account_number);
      formData.append("mobile", params.mobile);
      formData.append("channel", params.channel);
      formData.append("bene_name", params.bene_name);
      formData.append("bank_name", params.bank_name);
      formData.append("ifsc", params.ifsc);
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/secure/transaction', formData);
        if(response?.data?.status === 'success'){
          setTransactionId(response.data.id);
          setTransactionPopServiceName(response.data.service);
          setTransactionPopBankName(response.data.bene_bank);
          setTransactionPopTxnDate(response.data.txn_date);
          setTransactionPopAmount(response.data.amount);
          setTransactionPopMobile(response.data.mobile);
          setTransactionPopAccountNo(response.data.bene_account);
          setTransactionPopCustomerName(response.data.bene_name);
          setTransactionPopMethod(response.data.type);
          openConfirmTransactionModal();
        }else{
          setModalMsg(response.data.message);
          openModal('Error');
        }
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      } finally {
        setLoading(false); // Hide loader
      }
  }
  const payNow = async(confirmAmount,mpin) => {
    const localStorageDataStr = localStorage.getItem('token');
    const item = JSON.parse(localStorageDataStr);
    let formData = new FormData();
    formData.append("api_token", item.token);
    formData.append("amount", confirmAmount);
    formData.append("insert_id", transactionId);
    formData.append("mpin", mpin);
    try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/secure/confirm-transaction', formData);
        if(response?.data?.status === 'success'){
          setTransactionId("");
          setTransactionPopServiceName("");
          setTransactionPopBankName("");
          setTransactionPopTxnDate("");
          setTransactionPopAmount("");
          setTransactionPopMobile("");
          setTransactionPopAccountNo("");
          setTransactionPopCustomerName("");
          setTransactionPopMethod("");
          closeConfirmTransactionModal();
          setModalMsg(response.data.message);
          openModal('Success');
        }else{
          setModalMsg(response.data.message);
          openModal('Error');
        }
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      } finally {
        setLoading(false); // Hide loader
      }

  }
  const errorHandling = (type) => {
    const errors = {};
    if (type === 'mobile') {
      if (!mobile.trim()) {
        errors.mobile = 'Mobile is required';
      } else if (mobile.length !== 10) {
        errors.mobile = 'Mobile must be at least 10 digit long';
      }
    }else if (type === 'senderRegistration') {
      if (!senderName) {
        errors.senderName = 'Sender name is required';
      } else if (!otp) {
        errors.otp = 'Otp is required';
      }
    }else if (type === 'searchByAccount') {
      if (!beneAccountNo) {
        errors.beneAccountNo = 'Account no is required';
      }
    }else if(type === 'incorrectOtp'){
        errors.incorrectOtp = 'Incorrect OTP.';
    }else if(type === 'beneList'){
        if (!mobile.trim()) {
        errors.mobile = 'Mobile is required';
        }else if (mobile.length !== 10) {
          errors.mobile = 'Mobile must be at least 10 digit long';
        }else if (!accountNo.trim()) {
          errors.accountNo = 'Account no is required';
        }else if (accountNo.length < 10) {
          errors.accountNo = 'Account no must be at least 10 digit long';
        }
    }else if(type === 'upiList'){
        if (!mobile.trim()) {
        errors.mobile = 'Mobile is required';
        }else if (mobile.length !== 10) {
          errors.mobile = 'Mobile must be at least 10 digit long';
        }else if (!upiIdSearch.trim()) {
          errors.upiIdSearch = 'Upi id is required';
        }else if (!upiIdSearch.includes("@")) {
          errors.upiIdSearch = 'Please provide valid upi id';
        }
    }else if(type === 'accountVerify'){
        if (!mobile.trim()) {
        errors.mobile = 'Mobile is required';
        }else if (mobile.length !== 10) {
          errors.mobile = 'Mobile must be at least 10 digit long';
        }else if (!ifsc.trim()) {
          errors.ifsc = 'Ifsc is required';
        }else if (!accountNoAddBene.trim()) {
          errors.accountNoAddBene = 'Account no is required';
        }else if (accountNoAddBene.length < 10) {
          errors.accountNoAddBene = 'Account no is not correct';
        }
    }else if(type === 'addBeneficiary'){
        if (!mobile.trim()) {
          errors.mobile = 'Mobile is required';
        }else if (mobile.length !== 10) {
          errors.mobile = 'Mobile must be at least 10 digit long';
        }else if (!ifsc.trim()) {
          errors.ifsc = 'Ifsc is required';
        }else if (!accountNoAddBene.trim()) {
          errors.accountNoAddBene = 'Account no is required';
        }else if (accountNoAddBene.length < 10) {
          errors.accountNoAddBene = 'Account no is not correct';
        }else if (!beneNameAddBene.trim()) {
          errors.beneNameAddBene = 'Beneficiary name is required';
        }
    }else if(type === 'upiVerification'){
        if (!upiAddress.trim()) {
          errors.upiAddress = 'Upi id is required';
        }else if (!upiAddress.includes("@")) {
          errors.upiAddress = 'Upi id is invalid';
        }else if (!mobileAddUpi.trim()) {
          errors.mobileAddUpi = 'Mobile is required';
        }else if (mobileAddUpi.length !== 10) {
          errors.mobileAddUpi = 'Mobile must be at least 10 digit long';
        }
    }else if(type === 'addUpiBeneficiary'){
        if (!upiAddress.trim()) {
          errors.upiAddress = 'Upi id is required';
        }else if (!upiAddress.includes("@")) {
          errors.upiAddress = 'Upi id is invalid';
        }else if (!mobileAddUpi.trim()) {
          errors.mobileAddUpi = 'Mobile is required';
        }else if (mobileAddUpi.length !== 10) {
          errors.mobileAddUpi = 'Mobile must be at least 10 digit long';
        }else if (!beneNameAddUpi.trim()) {
          errors.beneNameAddUpi = 'Beneficiary name is required';
        }
    }else if(type === 'secureTransaction'){
        if (!upiAddress.trim()) {
          errors.upiAddress = 'Upi id is required';
        }else if (!upiAddress.includes("@")) {
          errors.upiAddress = 'Upi id is invalid';
        }else if (!mobileAddUpi.trim()) {
          errors.mobileAddUpi = 'Mobile is required';
        }else if (mobileAddUpi.length !== 10) {
          errors.mobileAddUpi = 'Mobile must be at least 10 digit long';
        }else if (!beneNameAddUpi.trim()) {
          errors.beneNameAddUpi = 'Beneficiary name is required';
        }
    }
    
    return errors;
  };

  return (
    <>
      <Header />
      <div className="adminuiux-wrap">
        <Sidebar />
        {loading ?
        <Loader/> :
        <main
          className="adminuiux-content has-sidebar"
        >
          {/*mt-4*/}
          <div className="container " id="main-content">
            <div className="row align-items-center">
            </div>
            {/* dashboard inner */}
              {confirmTransactionModal === 0 &&
              <div className="midde_cont">
                <div className="container-fluid">
                  <div className="row column_title">
                    <div className="col-md-12">
                      <div className="page_title d-sm-flex">
                        <h2>Money Transfer</h2>
                      </div>
                    </div>
                  </div> 
                  {showSenderSearchBoxDiv === 1 &&
                  <div className="row row-sm">
                    <div className="col-md-6">
                      <div className="card bd-0 shadow-base adminuiux-card">
                        <div
                          className="card-header tx-medium bd-0 tx-white"
                          style={{ padding: "0.75rem 1.25rem" }}
                        >
                          Search Customer
                        </div>
                        {/* card-header */}
                        <div className="card-body">
                          <fieldset noValidate="">
                              <form method="post" onSubmit={submitVerification}>
                            <div className="input-group">
                                <input
                                  type="text"
                                  name="mobile"
                                  className="form-control"
                                  placeholder="Sender Number"
                                  autoComplete="off"
                                  maxLength={10}
                                  value={mobile}
                                  onChange={(e) => { setMobile(e.target.value) }}
                                />
                                <div className="input-group-append" id="button-addon2">
                                  <button
                                    className="btn btn-primary waves-effect waves-light"
                                    type="submit"
                                    >
                                    Search
                                  </button>
                                </div>
                            </div>
                              {errors.mobile && (
                                <span className="error-message">
                                  {errors.mobile}
                                </span>
                              )}
                              </form>
                          </fieldset>
                        </div>
                        {/* card-body */}
                      </div>
                      {/* card */}
                    </div>
                    {/* card */}
                    <div className="col-md-6">
                      <div className="card bd-0 shadow-base adminuiux-card">
                        <div
                          className="card-header  tx-white"
                          style={{ padding: "0.75rem 1.25rem" }}
                        >
                          Search Beneficiary
                        </div>
                        {/* card-header */}
                        <div className="card-body">
                          <fieldset>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Account No"
                                aria-describedby="button-addon2"
                                maxLength={16}
                                value={beneAccountNo}
                                onChange={(e) => { setBeneAccountNo(e.target.value) }}
                              />
                              <div className="input-group-append" id="button-addon2">
                                <button
                                  className="btn btn-primary waves-effect waves-light"
                                  onClick={searchByAccount}
                                  type="button"
                                  >
                                  Search
                                  {errors.beneAccountNo && (
                                      <span className="error-message">
                                        {errors.beneAccountNo}
                                      </span>
                                    )}
                                </button>
                              </div>
                            </div>
                          </fieldset>
                        </div>
                        {/* card-body */}
                      </div>
                      {/* card */}
                    </div>
                    {/* card */}
                  </div>
                  }
                  {accountDetailBoxDiv === 1 &&
                    <div className="row row-sm">
                      <div className="col-md-6" />
                      <div className="col-md-6">
                        <div className="card bd-0 shadow-base adminuiux-card">
                          <div
                            className="card-header tx-medium bd-0 tx-white"
                            style={{ padding: "0.75rem 1.25rem" }}
                          >
                            Beneficiary Account Found
                          </div>
                          {/* card-header */}
                          <div className="card-body">
                            <div className="table-responsive">
                              <table className="table table-borderless mb-0 tx-12">
                                <thead>
                                  <tr>
                                    <th>Sender Mobile</th>
                                    <th>Beneficiary Name</th>
                                    <th>Account Number</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {beneList.map((item)=>(
                                  <tr>
                                    <td>{item.sender_mobile}</td>
                                    <td>{item.bene_name}</td>
                                    <td>{item.accountno}</td>
                                    <td><button className="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="top" title="Manage" onClick={showBeneList}>Manage</button></td>
                                  </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          {/* card-body */}
                        </div>
                        {/* card */}
                      </div>
                      {/* card */}
                    </div>
                  }
                  {showSenderDetailDiv === 1 &&
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card adminuiux-card">
                          <div className="card-content">
                            <div className="card-body pb-0">
                              <div className="row" style={{ padding: "0.55rem 1.25rem" }}>
                                <div className="col-md-6">
                                  <h4>
                                    Remitter :
                                    <span>{existingSenderName}</span>
                                  </h4>
                                </div>
                                <div className="col-md-6">
                                  <h4>
                                    Mobile :
                                    <span>{existingSenderMob}</span>
                                  </h4>
                                </div>                              
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  {showSearchAccountDiv === 1 &&
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card adminuiux-card">
                        <div className="card-content">
                          <div className="card-body pb-0">
                            <div className="row mb-3">
                              <div className="col-md-6 col-12 mb-1">
                                <fieldset>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Account No"
                                      id="saccount"
                                      aria-describedby="button-addon2"
                                      value={accountNo}
                                      onChange={(e) => { setAccountNo(e.target.value) }}
                                    />
                                    <div
                                      className="input-group-append"
                                      id="button-addon2"
                                      >
                                      <button
                                        className="btn btn-primary waves-effect waves-light"
                                        onClick={()=> getBeneList(0)}
                                        type="button"
                                        >
                                        Search
                                      </button>
                                    </div>
                                    &nbsp;
                                    <button
                                      className="btn btn-primary waves-effect waves-light"
                                      onClick={()=> getBeneList(1)}
                                      type="button"
                                      >
                                      View All
                                    </button>
                                  </div>
                                  {errors.accountNo && (
                                    <span className="error-message">
                                      {errors.accountNo}
                                    </span>
                                  )}
                                </fieldset>
                              </div>
                              <div className="col-md-6 col-12 mb-1">
                                <fieldset>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Search by UPI Address"
                                      value={upiIdSearch}
                                      onChange={(e) => { setUpiIdSearch(e.target.value) }}
                                    />
                                    <div className="input-group-append" id="s_upi_id_btn">
                                      <button
                                        className="btn btn-primary waves-effect waves-light"
                                        onClick={()=>getUpiList(0)}
                                        type="button"
                                      >
                                        Search
                                      </button>
                                    </div>
                                    &nbsp;
                                    <button
                                      className="btn btn-primary waves-effect waves-light"
                                      onClick={()=>getUpiList(1)}
                                      type="button"
                                    >
                                      View All
                                    </button>
                                  </div>
                                  {errors.upiIdSearch && (
                                    <span className="error-message">
                                      {errors.upiIdSearch}
                                    </span>
                                  )}
                                </fieldset>
                                {/* <small>
                                  {" "}
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-xs waves-effect waves-light"
                                    onclick="myFunction('@paytm')"
                                  >
                                    @paytm
                                  </button>
                                  ,{" "}
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-xs waves-effect waves-light"
                                    onclick="myFunction('@ybl')"
                                  >
                                    @ybl
                                  </button>{" "}
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-xs waves-effect waves-light"
                                    onclick="myFunction('@ibl')"
                                  >
                                    @ibl
                                  </button>
                                  ,
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-xs waves-effect waves-light"
                                    onclick="myFunction('@axl')"
                                  >
                                    @axl
                                  </button>
                                </small> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                  <div
                    className="row match-height mt-2"
                    id="main_box"
                  >
                    <div className="col-12">
                      <div className="form-body">
                        <div className="row">
                          <div className="col-md-6 col-sm-12 col-xs-12">
                            {showAddBeneBoxDiv === 1 &&
                            <div>
                              <div className="card bd-0 shadow-base adminuiux-card">
                                <div
                                  className="card-header tx-medium bd-0 tx-white"
                                  style={{ padding: "0.75rem 1.25rem" }}
                                >
                                  Add Beneficiary
                                </div>
                                <div className="card-body">
                                  <div className="form-group">
                                  <label htmlFor="email-id-vertical">Bank</label>
                                  <Select className="custom-dropdown" onChange={getIfsc} options={bankList}/>
                                    {errors.selectedBank && (
                                      <span className="error-message">
                                        {errors.selectedBank}
                                      </span>
                                    )}
                                    </div>
                                  <div className="form-group">
                                    <label>Account Number</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Account No"
                                      value={accountNoAddBene}
                                      onChange={(e) => setAccountNoAddBene(e.target.value)}
                                    />
                                    {errors.accountNoAddBene && (
                                      <span className="error-message">
                                        {errors.accountNoAddBene}
                                      </span>
                                    )}
                                  </div>
                                  <div className="form-group">
                                    <label>IFSC Code</label>
                                    <div className="input-group">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="ifsc_code"
                                        placeholder="IFSC Code"
                                        value={ifsc}
                                        onChange={(e) => { setIfsc(e.target.value) }}
                                      />
                                      {errors.ifsc && (
                                        <span className="error-message">
                                          {errors.ifsc}
                                        </span>
                                      )}
                                      <div className="input-group-append">
                                        <button
                                          className="btn btn-primary"
                                          id="button-addon2"
                                          onClick={getIfsc}
                                        >
                                          Get IFSC
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label>Beneficiary Name</label>
                                    <div className="input-group">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="bene_name"
                                        placeholder="Bene Name"
                                        readOnly
                                        value={beneNameAddBene}
                                      />
                                      <div className="input-group-append">
                                        <button
                                          className="btn btn-primary"
                                          id="button-addon2"
                                          onClick={accountVerification}
                                          >
                                          Name Verify
                                        </button>
                                      </div>
                                    </div>
                                      {errors.beneNameAddBene && (
                                        <span className="error-message">
                                          {errors.beneNameAddBene}
                                        </span>
                                      )}
                                  </div>
                                  <button
                                    type="submit"
                                    onClick={addBeneficiary}
                                    className="btn btn-sm btn-primary mr-1 mb-1 waves-effect waves-light"
                                  >
                                    Add Beneficiary
                                  </button>
                                </div>
                              </div>
                            </div>
                            }
                            {/*add bene close div*/}
                            {/*upi add box*/}
                            {showAddUpiBeneForm === 1 &&
                            <div>
                              <div className="card bd-0 shadow-base adminuiux-card">
                                <div
                                  className="card-header tx-medium bd-0 tx-white"
                                  style={{ padding: "0.75rem 1.25rem" }}
                                >
                                  Add UPI Beneficiary
                                </div>
                                <div className="card-body">
                              <div className="form-group">
                                <label>Upi Address</label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Upi Address"
                                    id="upi_address"
                                    value={upiAddress}
                                    onChange={(e) => { setUpiAddress(e.target.value) }}
                                  />                                
                                  <div className="input-group-append">
                                    <button
                                      className="btn btn-primary"
                                      id="upi_add_btn"
                                      onClick={upiVerification}
                                    >
                                      Upi Verify
                                    </button>
                                  </div>
                                </div>
                                {errors.upiAddress && (
                                    <span className="error-message">
                                      {errors.upiAddress}
                                    </span>
                                )}
                              </div>
                              <div className="form-group">
                                <label>Mobile Number</label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="upi_bene_mobile"
                                    placeholder="Mobile Number"
                                    aria-label="Mobile Number"
                                    aria-describedby="button-addon2"
                                    value={mobileAddUpi}
                                    onChange={(e) => { setMobileAddUpi(e.target.value) }}
                                  />
                                </div>
                                  {errors.mobileAddUpi && (
                                    <span className="error-message">
                                      {errors.mobileAddUpi}
                                    </span>
                                  )}
                              </div>
                              <div className="form-group">
                                <label>Beneficiary Name</label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="upi_bene_name"
                                    readOnly
                                    placeholder="Bene Name"
                                    aria-label="Bene Name"
                                    aria-describedby="upi_add_btn"
                                    value={beneNameAddUpi}
                                  />
                                </div>
                                {errors.beneNameAddUpi && (
                                  <span className="error-message">
                                    {errors.beneNameAddUpi}
                                  </span>
                                )}
                              </div>                            
                              <button
                                type="submit"
                                onClick={addUpiBeneficiary}
                                className="btn btn-sm btn-primary mr-1 mb-1 waves-effect waves-light"
                              >
                                Add Upi Address
                              </button>
                            </div>
                            </div>
                            </div>
                            }
                            {/*upi add box end*/}
                          </div>
                          <div className="col-md-8 col-sm-12 col-xs-12">
                            <div className="row">
                              <div className="col-md-6">
                                {/*add sender start div*/}
                                {showSenderDiv === 1 &&
                                  <div>
                                    <div className="card bd-0 shadow-base adminuiux-card">
                                    <div
                                      className="card-header tx-medium bd-0 tx-white"
                                      style={{ padding: "0.75rem 1.25rem" }}
                                    >
                                      Add Sender
                                    </div>
                                    <div className="card-body">
                                    <div className="form-group">
                                      <label>Sender Name</label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Full Name"
                                        value={senderName}
                                        onChange={(e) => { setSenderName(e.target.value) }}
                                      />
                                      {errors.senderName && (
                                        <span className="error-message">
                                          {errors.senderName}
                                        </span>
                                      )}
                                    </div>
                                    <div className="form-group">
                                      <label>Otp</label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Otp"
                                        value={otp}
                                        onChange={(e) => { setOtp(e.target.value) }}
                                      />
                                      {errors.otp && (
                                        <span className="error-message">
                                          {errors.otp}
                                        </span>
                                      )}
                                      {errors.incorrectOtp && (
                                        <span className="error-message">
                                          {errors.incorrectOtp}
                                        </span>
                                      )}
                                    </div>
                                    <button
                                      type="submit"
                                      className="btn btn-sm btn-primary mr-1 mb-1 waves-effect waves-light"
                                      onClick={senderRegistration}
                                    >
                                      Submit
                                    </button>
                                  </div>
                                  </div>
                                  </div>
                                }
                                {/*add sender close div*/}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-8 col-sm-12 col-xs-12" />
                          <div className="col-md-8 col-sm-12 col-xs-12" />
                          <div className="col-md-12 col-sm-12 col-xs-12">
                            <div
                              className="card adminuiux-card"
                              id="account_Details_box"
                              style={{ display: "none" }}
                            >
                              <span>Search By Account Number</span>
                              <div className="card-content">
                                <div className="table-responsive">
                                  <table className="table table-borderless mb-0 tx-12">
                                    <thead>
                                      <tr>
                                        <th>Sender Mobile</th>
                                        <th>Beneficiary Name</th>
                                        <th>Account Number</th>
                                        <th>Action</th>
                                      </tr>
                                    </thead>
                                    <tbody id="bene_list_by_account"></tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                            {showBeneListDiv === 1 &&
                            <div className="card adminuiux-card bd-0 shadow-base mt-5">
                              <div
                                className="card-header tx-medium bd-0 tx-white"
                                style={{ padding: "0.75rem 1.25rem" }}
                              >
                                Beneficiary List
                                <div style={{float:"right"}}>
                                <button className="btn btn-primary btn-sm tx-12" data-toggle="tooltip" data-placement="top" title="Transfer" onClick={showAddBeneBox}>Add Beneficiary</button>
                                </div>
                              </div>
                              {/* card-header */}
                              <div className="card-body">
                                <div className="table-responsive">
                                  <table className="table">
                                    <thead>
                                      <tr>
                                        <th>Verify</th>
                                        <th>Name</th>
                                        <th>Bank Name</th>
                                        <th>Account No</th>
                                        <th>Ifsc</th>
                                        <th>Amount</th>
                                        <th>IMPS</th>
                                        <th>NEFT</th>
                                        <th>Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {beneList.map((item,key)=>(
                                      <tr>
                                        <td>{item.name_validation == 1 ? <img src="https://kiaraapay.com/app-assets/images/check-circle.svg"/> : <img src='https://kiaraapay.com/app-assets/images/x-circle.svg'/> }</td>
                                        <td>{item.bene_name}</td>
                                        <td>{item.bank_name}</td>
                                        <td>{item.account_number}</td>
                                        <td>{item.ifsc}</td>
                                        <td>
                                          <input type="text" value={inputAmount[key]} onChange={(e) => handleChange(key, e)} style={{width:"100px"}}/>
                                          {errors[key] && (
                                            <span className="error-message">
                                              <br/>
                                              {errors[key]}
                                            </span>
                                          )}
                                        </td>
                                        <td><button className="btn btn-primary btn-sm tx-12" data-toggle="tooltip" data-placement="top" title="Transfer" onClick={() => createTransaction(key,item,2)}>IMPS</button></td> 
                                        <td><button className="btn btn-primary btn-sm tx-12" data-toggle="tooltip" data-placement="top" title="Transfer" onClick={() => createTransaction(key,item,1)}>NEFT</button></td>
                                        <td> | <a title="Delete" onClick={()=>deleteBene(item.bene_id)}><i className="bi bi-trash"></i></a></td>
                                      </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              {/* card-body */}
                            </div>
                            }
                            {/* card */}
                            {showUpiBeneListTable === 1 &&
                            <div className="card adminuiux-card bd-0 shadow-base mt-5">
                              <div
                                className="card-header tx-medium bd-0 tx-white"
                                style={{ padding: "0.75rem 1.25rem" }}
                              >
                              <b
                                className="tx-danger tx-center"
                                id="upibalMsg"
                                style={{ display: "none" }}
                              />
                                Upi List
                                <div style={{float:"right"}}>
                                <button className="btn btn-primary btn-sm tx-12" data-toggle="tooltip" data-placement="top" title="Add" onClick={showAddUpiBeneBox}>Add Upi Beneficiary</button>
                                </div>
                              </div>
                              <div className="card-content">
                                <div className="table-responsive">
                                  <table className="table table-borderless mb-0 tx-15">
                                    <thead>
                                      <tr>
                                        <th>Verify</th>
                                        <th>Bene Name</th>
                                        <th>Upi Address</th>
                                        <th>Bene Mobile</th>
                                        <th>Amount</th>
                                        <th>Upi Transfer/Action</th>
                                      </tr>
                                    </thead>
                                    <tbody id="upi_bene_list">
                                      {upiBeneList.map((item,key)=>(
                                      <tr>
                                        <td>{item.upi_validation == 1 ? <img src="https://kiaraapay.com/app-assets/images/check-circle.svg"/> : <img src='https://kiaraapay.com/app-assets/images/x-circle.svg'/> }</td>
                                        <td>{item.bene_name}</td>
                                        <td>{item.upi_address}</td>
                                        <td>{item.bene_mobile}</td>
                                        <td>
                                          <input type="text" value={inputAmount[key]} onChange={(e) => handleChange(key, e)} style={{width:"100px"}}/>
                                          {errors[key] && (
                                            <span className="error-message">
                                              <br/>
                                              {errors[key]}
                                            </span>
                                          )}
                                        </td>
                                        <td><button className="btn btn-primary btn-sm tx-12" data-toggle="tooltip" data-placement="top" title="Transfer" onClick={() => createTransaction(key,item,4)}>Transfer</button> |&nbsp;
                                        <a title="Delete" onClick={()=>deleteUpiBene(item.bene_id)}><i className="bi bi-trash"></i></a></td>
                                      </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }
              {confirmTransactionModal === 1 &&
                <ConfirmTransaction
                title="Confirm Transaction"
                closeConfirmTransactionModal={closeConfirmTransactionModal}
                transactionPopTxnDate={transactionPopTxnDate}
                transactionPopServiceName={transactionPopServiceName}
                transactionPopBankName={transactionPopBankName}
                transactionPopAmount={transactionPopAmount}
                transactionPopMobile={transactionPopMobile}
                transactionPopAccountNo={transactionPopAccountNo}
                transactionPopCustomerName={transactionPopCustomerName}
                transactionPopMethod={transactionPopMethod}
                payNow={payNow}
                />
              }
              {showAddBeneConfirmPopUp === 1 &&
                <ConfirmAddBene 
                title="Confirm Verification"
                accountNo={accountNoAddBene}
                bankName={selectedBankName}
                closeModal={closeModal}
                accountVerificationConfirm={accountVerificationConfirm}
                />
              }
              {showAddUpiConfirmPopUp === 1 &&
                <ConfirmUpiAddBene
                title="Confirm Verification"
                upiAddress={upiAddress}
                mobileNo={mobileAddUpi}
                closeUpiModal={closeUpiModal}
                upiVerificationConfirm={upiVerificationConfirm}
                />
              }
              {showErrorSuccessModal === 1 &&
                <ErrorSuccessModal
                  title={isErrorFlag === 0 ? 'Success' : 'Error'}
                  msg={modalMsg}
                  closeModal={closeModal}
                />
              }
          </div>
        </main>
        }
      </div>
    </>
  );
}